import "./CheckboxComponent.scss";

import React, { useMemo } from "react";
import { CheckmarkIconComponent } from "../../icons/CheckmarkIconComponent";
import { bemBlock } from "@ngd-web/lv-utils/ui/bemHelper";
import { cl } from "@ngd-web/lv-utils/ui/classNames";
import { uuidv4 } from "../../utils/utils";

export function CheckboxComponent({
    checked = false,
    title = "",
    onChange = e => null,
    children = null,
    className = null,
    disabled = false,
}) {
    const [bl, el] = bemBlock("CheckboxComponent");

    return (
        <label className={cl(bl(), className)}>
            <input
                type="checkbox"
                className={el("input", { titled: !!(title || children) })}
                checked={checked || false}
                onChange={onChange}
                disabled={disabled}
            />

            <span className={el("icon", { checked })}>
                <CheckmarkIconComponent />
            </span>

            <span>
                {title} {children}
            </span>
        </label>
    );
}

export function SplitCheckboxComponent({
    checked = false,
    title = "",
    onChange = e => null,
    className = null,
}) {
    const [bl, el] = bemBlock("CheckboxComponent");
    const id = useMemo(uuidv4, []);

    return (
        <>
            <label htmlFor={id}>{title}</label>

            <div className={cl(bl(), className)}>
                <input
                    id={id}
                    type="checkbox"
                    className={el("input")}
                    checked={checked || false}
                    onChange={onChange}
                />

                <span className={el("icon", { checked })}>
                    <CheckmarkIconComponent />
                </span>
            </div>
        </>
    );
}
